export const GET_DOCUMENT_DETAIL = "FUND@GET_DOCUMENT_DETAIL";
export const GET_DOCUMENT_DETAIL_INIT = "FUND@GET_DOCUMENT_DETAIL_INIT";
export const GET_DOCUMENT_DETAIL_SUCCESS = "FUND@GET_DOCUMENT_DETAIL_SUCCESS";
export const GET_DOCUMENT_DETAIL_FAILED = "FUND@GET_DOCUMENT_DETAIL_FAILED";

export const UPLOAD_DOCUMENT = "FUND@UPLOAD_DOCUMENT";
export const UPLOAD_DOCUMENT_INIT = "FUND@UPLOAD_DOCUMENT_INIT";
export const UPLOAD_DOCUMENT_SUCCESS = "FUND@UPLOAD_DOCUMENT_SUCCESS";
export const UPLOAD_DOCUMENT_FAILED = "FUND@UPLOAD_DOCUMENT_FAILED";

export const UPDATE_DOCUMENT_STATUS = "FUND@UPDATE_DOCUMENT_STATUS";
export const UPDATE_DOCUMENT_STATUS_INIT = "FUND@UPDATE_DOCUMENT_STATUS_INIT";
export const UPDATE_DOCUMENT_STATUS_SUCCESS =
  "FUND@UPDATE_DOCUMENT_STATUS_SUCCESS";
export const UPDATE_DOCUMENT_STATUS_FAILED =
  "FUND@UPDATE_DOCUMENT_STATUS_FAILED";
